/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

 /**
  * author: hao
  */
/* eslint-disable array-callback-return */
import { 
    findQuestionById,
    aoformQuestionShouldDisplay, 
    getInputContent,
    isAOFormConditionMatch,
    aoformValidationShouldDisplay
} from './AOFormUtils';
import { handleJsonToAnswer, handleFindAnswerbyQuestionIndicator, isHaveEinvoiceFun, isNeedFdeiSerFun } from './AOFormAnswerHandler2';
import { getContentByLocal, isStringEmpty, CheckNum } from './index'

export const  isArrayFn = (value) => {
	if (typeof Array.isArray === "function") {
		return Array.isArray(value)
	}else{
		return Object.prototype.toString.call(value) === "[object Array]"
	}
};

export const  isStrFn = (value) => {
	return typeof value === "string";
};

export const  isObjFn = (value) => {
	return typeof value === "object";
};

export const  isEmptyFn = (value) => {
	return !value;
};

export const numberOnly = (text) => {
    return text.replace(/\D+/g, '')
};

export const decimal = (text) => {
    let value = text;
    value = value.replace(/[^\d.]/g, "");
    value = value.replace(/^\./g, "");
    value = value.replace(/\.{2,}/g, ".");
    value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
    return value;
};

export const character = (text) => {
    let value = text;
    value = value.replace(/[^a-zA-Z]/g, '');
    return value;
};

export const formatCurrency = (num) => {
    if (num) {
         num = num.replace(/\b(0+)/gi,"");
        // if(''===num || isNaN(num)){return false;}
        const sign = num.indexOf("-") > 0 ? '-' : '';
        let cents = num.indexOf(".") > 0 ? num.substr(num.indexOf(".")) : '';
        // cents = cents.length>1 ? cents : '' ;
        num = num.indexOf(".") > 0 ? num.substring(0, (num.indexOf("."))) : num;
        // if('' === cents){ if(num.length>1 && '0' === num.substr(0,1)){return false;}}
        // else{if(num.length>1 && '0' === num.substr(0,1)){return false;}}

        for (let i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
            num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3));
        }
        return (sign + num + cents);
    } else {
        return num;
    }
};

export const chineseCharacterAndMark = (text) => {
    let value = text;
    value = value.replace(/[\u4e00-\u9fa5]/g, '');
    return value;
};

export const characterNnumber = (text) => {
    let value = text;
    value = value.replace(/[^a-zA-Z0-9]/g, '');
    return value;
};

export const email = (text) => {
    let value = text;
    value = value.replace(/\s+/g, '');
    return value;
};

export const percentage = (text) => {
    return !(!/^[\d,]*$/.test(text) || text.length > 3 || text > 100);
};

export const isEmail = (text) => {
    const reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/;
    return reg.test(text)
};

export const covertStringToDate = (str) => {
    const [date, month, year] = str.split('-');
    return new Date(`${year}/${month}/${date}`)
};

export const isDate = (yearStr, monthStr, dayStr) => {
    const year = parseInt(yearStr, 0);
    const month = parseInt(monthStr, 0);
    const day = parseInt(dayStr, 0);
    if (isNaN(year) || isNaN(month) || isNaN(day)) return false;
    if (year < 1000) return false;
    if (month > 12 || month < 1) return false;
    if (day < 1 || day > 31) return false;
    if ((month === 4 || month === 6 || month === 9 || month === 11) && (day > 30)) return false;
    if (month === 2) {
        if (day > 29) return false;
        if ((((year % 100 === 0) && (year % 400 !== 0)) || (year % 4 !== 0)) && (day > 28)) return false;
    }
    return true;
};

export const isCardNo = (card) => {
    //China and HongKong
    const cardNo = card.toUpperCase();
    const cardLength = card.split('1').length - 1;
    const reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9X]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)|(((\s?[A-Z])|([A-Z]{2}))\d{6}((\([0-9A]\))|([0-9A]))$)/;
    let result = reg.test(cardNo) && cardLength < 13;
    if (result) {
        const userDate = card.substring(12, 14) + "-" + card.substring(10, 12) + "-" + card.substring(6, 10)
        if (new Date() < covertStringToDate(userDate)) {
            result = false;
        }
    }
    return result;
};

export const entityGenVATTaxCondition = (app, question, subQuestion, tag) => {
    //RBBOB-15318
    const questionId = question && question.questionId;
    let entityGenVATTaxValue = "001";//if EntityGenVATTax->是
    if(questionId){
        if(tag === 'OfficePhone'){
            //RBBOB-15318
            if(questionId.substr(0,12) === "Q003-005-001" && questionId.substr(17,3) === "005"){
                const idx = questionId.substr(13,3);
                if(subQuestion.questionId === `Q003-005-001-${idx}-005-001` || subQuestion.questionId === `Q003-005-001-${idx}-005-003`){//PhoNumInvIssCountryCode, PhoNumInvIssTelephone
                    const aoFormSection = findQuestionById(app, "S003");
                    const { questions } = aoFormSection;
                    questions.map(item1 => {
                        if(item1.questionId === "Q003-005"){
                            item1.subQuestions.map(item2 => {
                                if(item2.questionId === "Q003-005-001"){
                                    item2.subQuestions.map(item3 => {
                                        if(item3.questionId === `Q003-005-001-${idx}`){
                                            item3.subQuestions.map(item4 => {
                                                if(item4.questionId === `Q003-005-001-${idx}-003` && item4.userAnswer && item4.userAnswer.chosenAnswerId && item4.userAnswer.chosenAnswerId === `A003-005-001-${idx}-003:002`) {//EntityGenVATTax->否
                                                    entityGenVATTaxValue = "002";
                                                }
                                            })
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
            }
        } else {
            if(questionId.substr(0,12) === "Q003-005-001" && (questionId.substr(17,3) === "006" || questionId.substr(17,3) === "007")) {//NamOfBanForTaxPur, AccNumForTaxPur            
                const idx = questionId.substr(13,3);
                const aoFormSection = findQuestionById(app, "S003");
                const { questions } = aoFormSection;
                questions.map(item1 => {
                    if(item1.questionId === "Q003-005"){
                        item1.subQuestions.map(item2 => {
                            if(item2.questionId === "Q003-005-001"){
                                item2.subQuestions.map(item3 => {
                                    if(item3.questionId === `Q003-005-001-${idx}`){
                                        item3.subQuestions.map(item4 => {
                                            if(item4.questionId === `Q003-005-001-${idx}-003` && item4.userAnswer && item4.userAnswer.chosenAnswerId && item4.userAnswer.chosenAnswerId === `A003-005-001-${idx}-003:002`) {//EntityGenVATTax->否
                                                entityGenVATTaxValue = "002";
                                            }
                                        })
                                    }
                                })
                            }
                        })
                    }
                })
            }
        }
    }
 return entityGenVATTaxValue;
}

// return [isError, error message]
export const validationQuestion = (app, question, form_base_content, selectedLanguage, businessInfo, countryListDatas) => {
    // 先判断这道题需不需要显示，如果不需要显示则不用做checking
    const shouldDisplay = aoformQuestionShouldDisplay(app, question);
    if (!shouldDisplay) {
        return [false];
    }
    const {
        userAnswer,
        answerType,
        subQuestions,
        condition
    } = question;
    let tempUserAnswer = null;
    let isSkip = false;
    const requireErrorMsg = form_base_content.error_msg;
    const form_error_prompt = form_base_content.form_error_prompt;
    switch (answerType) {
        case 1: // Radio button
            tempUserAnswer = userAnswer && userAnswer.chosenAnswerId;
            break;
        case 5: // Drop down list 
        case 27:
            tempUserAnswer = userAnswer && userAnswer.chosenAnswerId;
            break;
        case 2: // CheckBox
            tempUserAnswer = userAnswer && userAnswer.chosenAnswerId.split(',');
            break;
        case 4: // Input Field
        case 21: // InputDigit
        case 24: // TextArea
        case 23: // InputPercentage
            tempUserAnswer = userAnswer && getInputContent(userAnswer);
            break;
        case 7: // Mobile Phone
        case 8: // Office Phone
            {
                let isValidationMoblie = false;
                let validationMobileMsg = "";
                const initValue = answerType === 7 ? "-" : "--";
                const defaultValue = userAnswer ? getInputContent(userAnswer) : initValue;
                if (defaultValue || defaultValue === "") {
                    const dates = defaultValue.split("-");
                    let isError = false;
                    
                    const mandatorys = subQuestions && subQuestions.map(subQuestion => {
                        const { condition } = subQuestion;
                        const conditionObj = JSON.parse(condition);
                        let mandatory = true;
                        if (conditionObj) {
                            mandatory = conditionObj.mandatory;
                            //RBBOB-15318
                            if(entityGenVATTaxCondition(app, question, subQuestion, "OfficePhone") === "002"){
                                mandatory = false;
                            }
                        }
                        return mandatory;
                    });
                    let length = 0;
                    if (mandatorys) {
                        length = mandatorys.length
                    }
                    for (let i = 0; i < length; i++){
                        let mandatory = mandatorys[i];
                        let date = dates[i];
                        if (mandatory && !(new RegExp('.+').test(date))) {
                            isError = true;
                        }
                        // WCB-8707 validation 852 and 86
                        if(answerType === 7) { // 手机号码: 国家/地区代码 + 电话号码
                            if(["86","086","+86"].indexOf(dates[0]) > -1) {
                                if(dates[1].length !=11){
                                    isError = true;
                                    isValidationMoblie = true;
                                    validationMobileMsg = form_error_prompt.errorInfo_Mobile11Digits;
                                } else {
                                    isValidationMoblie = false;
                                    validationMobileMsg = "";
                                }
                            }
                            if(["852"].indexOf(dates[0]) > -1) {
                                if(dates[1].length !=8){
                                    isError = true;
                                    isValidationMoblie = true;
                                    validationMobileMsg = form_error_prompt.errorInfo_Mobile8Digits;
                                } else {
                                    isValidationMoblie = false;
                                    validationMobileMsg = "";
                                }
                            }
                        }
                    }
                    
                    // if (mandatory) {
                    //     dates.forEach((value, index) => {
                    //         if (answerType === 8) {
                    //             if (index !== 1 && !(new RegExp('.+').test(value))) {
                    //                 isError = true;
                    //             }
                    //         } else {
                    //             if (!(new RegExp('.+').test(value))) {
                    //                 isError = true;
                    //             }
                    //         }
                            
                    //     });
                    // }
                    if (isError) {
                        // addError(errorList, itemIndex, questionId);
                        // errorMsgs[questionId] = requireErrorMsg;
                        if(isValidationMoblie){
                            return [true, validationMobileMsg];
                        } else {
                            return [true, requireErrorMsg];
                        }
                    }
                }
                // removeFormErrorList(errorList, itemIndex)
                
                return [false]
            }
        case 16: // Input Date
            {
                const defaultValue = userAnswer ? getInputContent(userAnswer) : "--";
                if (defaultValue) {
                    const dates = defaultValue.split("-");
                    let isError = false;
                    dates.forEach(value => {
                        if (!(new RegExp('.+').test(value))) {
                            isError = true
                        }
                    });
                    if (isError) {
                        // addError(errorList, itemIndex, questionId);
                        // errorMsgs[questionId] = requireErrorMsg;
                        return [true, requireErrorMsg]
                    } else {
                        if (!isDate(dates[2], dates[1], dates[0])) {
                            // addError(errorList, itemIndex, questionId);
                            // // TODO: need to change the msg
                            // errorMsgs[questionId] = form_base_content.invalid_date;
                            return [true, form_base_content.invalid_date]
                        } else {
                            const conditionObj = JSON.parse(condition);
                            if (conditionObj) {
                                const { validations } = conditionObj;
                                if (validations) {
                                    const length = validations.length;
                                    for (let i = 0; i < length; i++) {
                                        const validation = validations[i];
                                        const { type, errorLocales } = validation;
                                        const now = new Date();
                                        const userDate = covertStringToDate(defaultValue);
                                        if (type === 0) {
                                            if (now < userDate) {
                                                // addError(errorList, itemIndex, questionId);
                                                // errorMsgs[questionId] = getContentByLocal(errorLocales, selectedLanguage);
                                                return [true, getContentByLocal(errorLocales, selectedLanguage)]
                                            }
                                        } else if (type === 11) {
                                            if (now > userDate) {
                                                // addError(errorList, itemIndex, questionId);
                                                // errorMsgs[questionId] = getContentByLocal(errorLocales, selectedLanguage);
                                                return [true, getContentByLocal(errorLocales, selectedLanguage)]
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    
                }
                return [false];
            }
        default:
            {
                isSkip = true;
                break;
            }
    }

    if (!isSkip) {
        const [isErrorShouldDisplay, errorMsg] = aoformValidationShouldDisplay(app, question)
        const conditionObj = JSON.parse(condition);
        let mandatory = true;
        if (conditionObj) {
            mandatory = conditionObj.mandatory;
            if(conditionObj.otherMandatory){ // 新增一个覆盖mandatory的logic, 如果存在otherMandatory标签，就跑着个logic覆盖.
                mandatory = otherMandatoryLogic(conditionObj, app, businessInfo, countryListDatas);
            }
            //RBBOB-15318
            if(entityGenVATTaxCondition(app, question, "", "") === "002"){
                mandatory = false;                    
            }
        }
        if (isErrorShouldDisplay) {
            return [true, getContentByLocal(errorMsg, selectedLanguage)]
        }
        let hasAnswer = false;
        if (Array.isArray(tempUserAnswer)) {
            hasAnswer = tempUserAnswer.length > 0 && tempUserAnswer.reduce((sum, value) => {
                return sum || !isStringEmpty(value)
            }, false)
        } else {
            hasAnswer = !isStringEmpty(tempUserAnswer)
        }
        
        if (mandatory || hasAnswer) {   
            const { inputType, validations } = conditionObj;
            const { questionIndicator } = question; 

            // 实收金额 or 注册金额 logic验证
            if(questionIndicator ===  "FctCapAmt" || questionIndicator ===  "CapitalAmount") { 
                const amt = handleFindAnswerbyQuestionIndicator(app, questionIndicator);
                if(amt !== "" && !CheckNum(amt)){
                    return [true, form_base_content.invalid_format];
                }
            }

             // 税务信息，如需“数电发票”服务，请回到第3步填写电邮地址并勾选“电子发票”项
            if (questionIndicator === "NeedFdeiSer" || questionIndicator === "EmailUsage") {
                const isNeedFdeiSer = isNeedFdeiSerFun(app, countryListDatas);
                const isHaveE = isHaveEinvoiceFun(app, countryListDatas);
                if (isNeedFdeiSer) {
                    if (!isHaveE) {
                        return questionIndicator === "NeedFdeiSer" ? [true, form_base_content.invalid_fdei]:[true, form_base_content.invalid_fdei_email];
                    }
                }
            }
            
            if (!(new RegExp('.+').test(tempUserAnswer || ""))) {
                // addError(errorList, itemIndex, questionId);
                // errorMsgs[questionId] = requireErrorMsg
                if (validations) {
                    for (let i = 0; i < validations.length; i++) {
                        const validation = validations[i];
                        const { type, errorLocales } = validation;
                        switch (type) {
                            case 14: // Check Length
                                return [true, getContentByLocal(errorLocales, selectedLanguage)]
                            default:
                                return [true, requireErrorMsg];
                        }
                    }
                } else {
                    return [true, requireErrorMsg];
                }
            } else {
                if (typeof (inputType) !== "undefined") {
                    switch (inputType) {
                        case 4:
                            if (!isEmail(tempUserAnswer)) {
                                return [true, form_base_content.invalid_email]
                            }
                            break;
                        default:
                            break;
                    }
                }
                if (validations) {
                    for (let i = 0; i < validations.length; i++) {
                        const validation = validations[i];
                        const { condition } = validation;
                        let needChecking = false;
                        if (condition) {
                            if (isAOFormConditionMatch(app, condition, question, false)) {
                                needChecking = true;
                            }
                        } else {
                            needChecking = true;
                        }
                        if (needChecking) {
                            const { type, errorLocales, value } = validation;
                            switch (type) {
                                case 12: // China IdCard
                                    if (!isCardNo(tempUserAnswer)) {
                                        return [true, getContentByLocal(errorLocales, selectedLanguage)]
                                    }
                                break;
                                case 0:
                                case 11:
                                    {
                                        const now = new Date();
                                        const defaultValue = "01-01-" + tempUserAnswer;
                                        const userDate = covertStringToDate(defaultValue);
                                        if (type === 0) {
                                            const year = parseInt(tempUserAnswer, 0);
                                            if (isNaN(year) || year < 1000) return [true, form_base_content.invalid_date];
                                            if (now < userDate) {
                                                // addError(errorList, itemIndex, questionId);
                                                // errorMsgs[questionId] = getContentByLocal(errorLocales, selectedLanguage);
                                                return [true, getContentByLocal(errorLocales, selectedLanguage)]
                                            }
                                        } else if (type === 11) {
                                            if (now > userDate) {
                                                // addError(errorList, itemIndex, questionId);
                                                // errorMsgs[questionId] = getContentByLocal(errorLocales, selectedLanguage);
                                                return [true, getContentByLocal(errorLocales, selectedLanguage)]
                                            }
                                        }
                                    }
                                break;
                                case 13: // Check Length
                                  if ((tempUserAnswer || "").length < parseInt(value, 10)) {
                                    return [true, getContentByLocal(errorLocales, selectedLanguage)]
                                  }
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                }
                
            }
        }
    }
    return [false]
};

export const otherMandatoryLogic = (conditionObj, newApplicationInfo, businessInfo, countryListDatas) => {
    // const [flattenObj, panelStatusObj] = handleJsonToAnswer(newApplicationInfo, countryListDatas);
    const onShore = !businessInfo.companyInfo.offShore;
    let newMandatory = false;
    const indicator = conditionObj && conditionObj.otherMandatory;
    switch (indicator) {
        case "CapitalCurrency" :
            if(onShore) {
                newMandatory =  true; // 如果是onshore, 注册资本 -> 币种 要必填。
            }
            break;
        case "CapitalAmount" :
            if(onShore) {
                newMandatory =  true; // 如果是onshore, 注册资本 -> 金额 要必填。
            }
            break;
        case "FctCapCur" :
            if(onShore) {
                newMandatory =  true; // 如果是onshore, 实收资本 -> 币种 要必填。
            }
            break;
        case "FctCapAmt" :
            if(onShore) {
                newMandatory =  true; // 如果是onshore, 实收资本 -> 金额 要必填。
            }
            break;
        case "OthKeyFinDataAssAmount":
            if(onShore) {
                newMandatory =  true; // 如果是onshore, 资产规模金额 要必填。
            }
            break;
        default:
            {
                newMandatory = false;
                break;
            }
    }
    return newMandatory;
}


// WEBPACK FOOTER //
// ./src/utils/ValidationUtils.js